import * as Sentry from "@sentry/react";
export default function initSentry() {
    Sentry.init({
        dsn: "https://00417f01b6e14ee195d96acd204fb266@o4511270348390400.ingest.us.sentry.io/4511270352584705",
        integrations: [
            Sentry.browserTracingIntegration({
                traceFetch: true, // Enable tracing for fetch API
                traceXHR: true,   // Enable tracing for XMLHttpRequest
            }),
            Sentry.replayIntegration(),
            // send console.log, console.warn, and console.error calls as logs to Sentry
            // Sentry.consoleLoggingIntegration({ levels: ["error"] }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE ? parseFloat(import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE) : 0.2,
        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/kopilibrasi.web.id\//],
        enableLogs: true,
        environment: import.meta.env.VITE_MODE_ENV || "development",
        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE ? parseFloat(import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE) : 0.1,
        replaysOnErrorSampleRate: 1.0,
        beforeSend(event) {
            // contoh: hapus data sensitif
            if (event.request?.headers) {
                delete event.request.headers.Authorization;
            }
            return event;
        }
    });
}